import { AvailableIcons } from 'src/components-dummy';
import { DomainEntityPath } from 'src/services';
import { DomainGroup, SubDomainGroupBase } from '../../types';
import { inspirationGalleryDiffSchema } from './inspiration-gallery-diff-schema';

export const inspirationGalleryDomainGroup: DomainGroup &
  SubDomainGroupBase<Record<string, unknown>> = {
  domainKey: DomainEntityPath.InspirationGallery,
  title: 'Inspiration Gallery',
  icon: AvailableIcons.Setting,
  getCardTitle: () => 'Inspiration Gallery',
  fieldsSchema: inspirationGalleryDiffSchema,
};
